/**
 * Web — Pro is Stripe Checkout. Apple IAP is iOS-only.
 */

export type AppleIapResult = 'success' | 'cancelled';

export function isAppleIapAvailable(): boolean {
  return false;
}

export function isAppleIapUserCancelled(_error: unknown): boolean {
  return false;
}

export async function initAppleIap(): Promise<void> {
  // no-op
}

export async function purchaseProSubscription(): Promise<AppleIapResult> {
  throw new Error('Apple In-App Purchase is only available on iOS');
}

export async function restoreProPurchases(): Promise<boolean> {
  throw new Error('Restore purchases is only available on iOS');
}

export function subscribeToApplePurchases(
  _onPurchase: (purchase: unknown) => void,
): () => void {
  return () => undefined;
}

export async function syncApplePurchase(_purchase: unknown): Promise<void> {
  // no-op
}

export async function openAppleSubscriptions(): Promise<void> {
  throw new Error('Apple subscriptions are only available on iOS');
}
